import React from 'react'
import './scheduling-helper-2024.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { addMonths, eachDayOfInterval, endOfMonth, format, parse, startOfMonth, subMonths } from 'date-fns'
import { createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime } from '../../Calendar/calendarFunctions'
import { MdClose, MdDriveEta, MdHome, MdLockClock, MdPunchClock, MdSchedule, MdTimeline, MdWatch, MdWatchOff } from 'react-icons/md'

const SchedulingHelper2024 = ({schedulingHelperTeacherId, teacherDistanceSuggestions, setSchedulingHelperTeacherId}) => {
    const [teacherInfo, setTeacherInfo] = React.useState({})
    const [calendarEvents, setCalendarEvents] = React.useState([])
    const [calendarDaysWithEvents, setCalendarDaysWithEvents] = React.useState(false)
    const [scrollCalendar, setScrollCalendar] = React.useState(false)

    React.useEffect(() => {
        if(!schedulingHelperTeacherId) return
        axios.get(`${baseUrl}/teacher-availability/${schedulingHelperTeacherId}`)
        .then(res => {
            setTeacherInfo(res.data)
        })
        .catch(err => console.log(err))
        axios.get(`${baseUrl}/calendar/teacher/${schedulingHelperTeacherId}`)
        .then(res => {
            setCalendarEvents(res.data)
        })
        .catch(err => console.log(err))
    }, [schedulingHelperTeacherId])

    React.useEffect(() => {
        if(teacherInfo.Name) {
            setScrollCalendar(getDatesWithEvents(calendarDaysWithEvents))
        }
    }, [calendarDaysWithEvents, teacherInfo])

    React.useEffect(() => {
        generateScrollCalendar(calendarEvents)
    }, [calendarEvents])

    const weekdays = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']

    const generateScrollCalendar = async (calendarEvents) => {
        const allDates = eachDayOfInterval({start: new Date(), end: addMonths(new Date(), 1)});
        createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime(allDates, calendarEvents, setCalendarDaysWithEvents);
    }

    const createEllipsis = (text, length) => {
        if(!text) return
        return text.length > length ? text.substring(0, length) + '...' : text;
    }

    const formatStudentName = (studentName, familyName) => {
        if(!studentName) return;
        // Convert both names to lowercase to make the comparison case-insensitive
        const lowerStudentName = studentName.toLowerCase();
        const lowerFamilyName = familyName.toLowerCase();
        
        // Only remove familyName if it's part of the studentName, but not if studentName equals familyName
        if (lowerStudentName !== lowerFamilyName && lowerStudentName.includes(lowerFamilyName)) {
          const regex = new RegExp(`\\b${familyName}\\b`, 'i'); // Use regex to remove the family name as a word
          studentName = studentName.replace(regex, '').trim(); // Remove familyName and trim extra spaces
        }
      
        // Return the formatted name
        return `${studentName} ${familyName}`.trim();
      }

      const formatTeacherAvailabilityIntoCalendarEvent = (availability) => {
        for(let i = 0; i < availability.length; i++) {
            if(availability[i].start && availability[i].end) {
                return {studentName: 'AVAILABLE', familyName: `${format(parse(availability[i].start, 'H:mm', new Date()), 'h:mm a')} - ${format(parse(availability[i].end, 'H:mm', new Date()), 'h:mm a')}`}
            }
        }
      }

      const getDatesWithEvents = (data) => {
        // Create a new object to store the dates with events
        const result = {};
      
        // Loop through the data object using Object.entries
        Object.entries(data).forEach(([date, value]) => {
          // Check if the events array is not empty
          if(teacherInfo.AvailabilityDetails[format(parse(date, 'yyyy-MM-dd', new Date()), 'EEEE')].length > 0) {
            if(!result[date]) result[date] = []
            result[date].push(formatTeacherAvailabilityIntoCalendarEvent(teacherInfo.AvailabilityDetails[format(parse(date, 'yyyy-MM-dd', new Date()), 'EEEE')]))
        } 
         if (value.events.length > 0) {
            if(!result[date]) result[date] = []
            for(let i = 0; i < value.events.length; i++) {
                result[date].push(value.events[i])
            }
          }
        });
        
        //sort the events by time
        for (const date in result) {
            result[date].sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime));
        }

        return result;
      }

      const createEventEndTime = (event) => {
        //add lessonLength to the start time
        let time = new Date(event.dateTime)
        let endTime = time.setMinutes(time.getMinutes() + event.lessonLength)
        //return the formatted time
        return format(new Date(endTime), 'h:mm a')
      }

      const findDriveTime = (event, distanceSuggestions) => {
        //find the teacherDistanceSuggestions object that matches the teacherId
        let familyId = event.familyId
        let teacherDistance = distanceSuggestions.find(sugg => sugg.eventOrTeacherObject.familyId === familyId)
        //return the drive time
        if(teacherDistance) {
            return teacherDistance.duration
        } else {
            return 'Unavailable'
        }
      }

      const findDriveTimeFromTeachersHome = (event, distanceSuggestions) => {
        let teacherDistance = distanceSuggestions.find(sugg => (sugg.eventOrTeacherObject.type === 'teacher') && (sugg.eventOrTeacherObject.name === teacherInfo.Name))
        //return the drive time
        if(teacherDistance) {
            return teacherDistance.duration
        } else {
            return 'No drive time available'
        }
      }

    return (
        teacherInfo?.Name ?
        <div className='scheduling-helper-column'>
            <div className='scheduling-helper-column__header-wrapper'>
                <div className='scheduling-helper-column__teacher-name'>{teacherInfo?.Name}</div>
                <div className='scheduling-helper-column__closer' onClick={() => setSchedulingHelperTeacherId(false)}><MdClose size={24} color='#94A3B8' /></div>
            </div>
            <div className='scheduling-helper-column__notes'>{teacherInfo.Notes}</div>
            <div>        
                {/* <div className="scheduling-column__teacher-availabilities">
                    {weekdays.map((day) => 
                        <div key={day} className="scheduling-column__teacher-availabilities__each-day">
                            {teacherInfo?.AvailabilityDetails[day].length > 0 &&
                                <div className='scheduling-column__teacher-avail__each'>
                                    <div className='scheduling-column__teacher-avail__each-day'><strong>{day}</strong></div>
                                    {teacherInfo?.AvailabilityDetails[day].map((times, i) => <div className="scheduling-column__each-availability-strip" key={i}> {times.start && format(parse(times.start, 'H:mm', new Date()), 'h:mm a')} to { times.end && format(parse(times.end, 'H:mm', new Date()), 'h:mm a')}</div>)}
                                </div>
                            }
                        </div>
                    )}
                </div> */}
            </div>
                    {scrollCalendar &&
                        <div>
                                <div className='scheduling-helper-column__main-scroll'>
                                    {
                                        Object.entries(scrollCalendar).map(([date, events]) => (
                                            <div key={date} className='scheduling-helper-column__each-date'>
                                                <div className='scheduling-helper-column__date' >
                                                    <div className='scheduling-helper-column__date-day'>{format(parse(date, 'yyyy-MM-dd', new Date()), 'E').toUpperCase()}</div>
                                                    <div className='scheduling-helper-column__date-month'>{format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM').toUpperCase()}</div>
                                                    <div className='scheduling-helper-column__date-number'>{format(parse(date, 'yyyy-MM-dd', new Date()), 'd')}</div>
                                                    
                                                </div>
                                                <div className='scheduling-helper-column__each-event__wrapper'>
                                                    {events.map(event => (
                                                        event.studentName === 'AVAILABLE' ?
                                                        <div key={event._id} className='scheduling-helper-column__each-event__availability'>
                                                            <div className='scheduling-helper-column__each-event__availability__title'>
                                                                <div>{event.studentName}</div>
                                                                <div className='scheduling-helper-column__each-event__availability__drive-time__wrapper'>
                                                                    <MdHome color='#94A3B8' size={10} />
                                                                    <div>{findDriveTimeFromTeachersHome(event, teacherDistanceSuggestions)}</div>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className='scheduling-helper-column__each-event__availability__time-wrapper'>
                                                                <MdSchedule size={14} fill='#4BA2E3' />
                                                                <div className='scheduling-helper-column__each-event__availability__time'>{event.familyName}</div>
                                                            </div>
                                                            
                                                            
                                                        </div>
                                                        :
                                                        <div key={event._id} className='scheduling-helper-column__each-event'>
                                                            <div className='scheduling-helper-column__each-event__availability__title'>
                                                               <div>{createEllipsis(formatStudentName(event.studentName, event.familyName), 13)}</div>
                                                               <div className='scheduling-helper-column__each-event__availability__drive-time__wrapper'>
                                                                    <MdDriveEta color='#94A3B8' size={10} />
                                                                    <div>{findDriveTime(event, teacherDistanceSuggestions)}</div>
                                                               </div>
                                                            </div>
                                                            <div className='scheduling-helper-column__each-event__availability__time-wrapper'>
                                                                <MdSchedule size={14} fill='#4BA2E3' />
                                                                <div className='scheduling-helper-column__each-event__availability__time'>{format(new Date(event.dateTime), 'h:mm a')} - {createEventEndTime(event)}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                    }
        </div>
            :

                <div>Loading...</div>
    )
}
export default SchedulingHelper2024;